<form [formGroup]="form">
<mat-accordion *ngIf="consentId !== '3'">
  <div class="ps-lgpd-signature-list" formArrayName="signatures" cdkDropList (cdkDropListDropped)="changesPositionOfTheSignatures($event)">
    <div *ngFor="let signature of formControlSignatures.controls | keyvalue: asIs; async"
    [formGroupName]="signature.key"
    cdkDragLockAxis="y"
    cdkDrag>
      <mat-expansion-panel [ngClass]="{signatureInvalid: signature.value.status === 'INVALID'}">
        <mat-expansion-panel-header cdkDragHandle>
          <mat-panel-title class="ps-lgpd-signature-title">
            <!-- <mat-icon>drag_indicator</mat-icon> -->
            {{formControlSignatures.value[signature.key].signature_id ? formControlSignatures.value[signature.key].signature_id.assinatura : 'Selecione o tipo de assinatura'}}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div fxLayout="row">
          <mat-form-field appearance="fill" fxFill>
            <mat-label>Tipo de assinatura *</mat-label>
            <mat-select formControlName="signature_id">
              <mat-option
                *ngFor="let availableSignature of availableSignatures"
                [value]="availableSignature"
                [disabled]="disablesAlreadySelectedSignatures(availableSignature)">
                {{availableSignature.assinatura}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxLayout="row">
          <div fxFlex>
            <app-textarea-with-editor *ngFor="let item of reset"
              [height]="200"
              [label]="'Rótulo da caixa de seleção'"
              [form]="signature.value"
              [controlName]="'label'">
            </app-textarea-with-editor>
          </div>
        </div>
        <div fxLayout="row">
          <div fxFlex>
            <app-autocomplete-system-fields
              [systemFields]="nonMultivalueFields"
              [formulario]="signature.value"
              [nameControl]="'field_id_to_save_signature'"
              [matTooltipText]="'O campo vinculado não deverá ser um campo multivalorado'"
              [label]="'Vincular campo'">
            </app-autocomplete-system-fields>
          </div>
        </div>
        <div fxLayout="row">
          <div fxFlex fxLayoutAlign="start center">
            <mat-checkbox color="primary" formControlName="required">Tornar este campo obrigatório</mat-checkbox>
          </div>
          <div fxFlex fxLayoutAlign="end center">
            <button
              [disabled]="disableDeleteButton(formControlSignatures.value[signature.key].signature_id)"
              (click)="deleteSignature(signature.key)"
              class="ps-lgpd-signature-btn-delete"
              mat-button
              color="warn">
              <mat-icon>delete</mat-icon>
              Excluir
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </div>
</mat-accordion>
<div fxLayout="row" [style.margin-top.px]="20" *ngIf="consentId !== '3'">
  <div fxFlex>
    <button
      (click)="addSignature({obrigatorio: '0'})"
      class="ps-lgpd-signature-btn-add"
      disableRipple="true"
      mat-button
      color="primary">
      <mat-icon>add</mat-icon>
      Adicione outra caixa de seleção
    </button>
  </div>
</div>
<!-- tipo 3 -->
<div
  fxLayout="row"
  *ngIf="consentId === '3'"
  class="ps-row">
  <div fxFlex>
    <mat-form-field appearance="fill" fxFlex>
      <mat-label>Tipo de assinatura</mat-label>
      <mat-chip-list #chipList aria-label="Seleção de assinatura">
        <mat-chip
          *ngFor="let formSignature of formControlSignatures.value; let i = index;"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="removeChipSignature(i)">
          {{formSignature.label}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input
          matInput
          #signatureInput
          [formControl]="autoCompleteSignatureCtrl"
          [matAutocomplete]="autocompleteSignatures"
          [matChipInputFor]="chipList">
      </mat-chip-list>
      <mat-autocomplete
        #autocompleteSignatures="matAutocomplete"
        (optionSelected)="selectedChipSignature($event)">
        <mat-option
          *ngFor="let signature of filteredSignatures | async"
          [disabled]="disablesAlreadySelectedSignatures(signature)"
          [value]="signature">
          {{signature.assinatura}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</div>
<div fxLayout="row" *ngIf="consentId === '3'">
  <div fxFlex>
    <app-autocomplete-system-fields
      [systemFields]="nonMultivalueFields"
      [formulario]="form"
      [nameControl]="'field_id_to_save_legitimate_interests'"
      [matTooltipText]="'O campo vinculado não deverá ser um campo multivalorado'"
      [label]="'Vincular campo'">
    </app-autocomplete-system-fields>
  </div>
</div>
</form>
